import { SELECT_BUTTON_CLASS_NAME, SUMMARY_FILTER_SELECT_CLASS_NAME } from '../../constants/select';
import FingoMuiSelect, { selectButton, summaryFilterSelect } from '../../fingo/components/MuiSelect';

const MuiSelect = {
  styleOverrides: {
    ...FingoMuiSelect.styleOverrides,
    root: ({ theme }) => ({
      ...FingoMuiSelect.styleOverrides.root({ theme }),
      [`&.${SELECT_BUTTON_CLASS_NAME}`]: selectButton({
        theme,
        mainColor: theme.palette.secondary.A400,
      }),
      [`&.${SUMMARY_FILTER_SELECT_CLASS_NAME}`]: summaryFilterSelect({ theme, mainColor: theme.palette.secondary.A400 }),
    }),
  },
};

export default MuiSelect;
